import { EnrolledBeneficiaryType } from "@/types/beneficiaries";
import { useBeneficiaryCalculations } from "@/hooks/useBeneficiaryCalculations";
import BeneficiaryHeader from "./BeneficiaryHeader";
import BeneficiaryOverview from "./BeneficiaryOverview";
import VestingSection from "./VestingSection";
import ContributionsGrid from "./ContributionsGrid";

interface BeneficiaryCardProps {
  beneficiary: EnrolledBeneficiaryType;
  onManageContributions: (accountNumber: string) => void;
}

const BeneficiaryCard = ({
  beneficiary,
  onManageContributions,
}: BeneficiaryCardProps) => {
  const calculations = useBeneficiaryCalculations(beneficiary);
  const beneficiaryName = `${beneficiary.minorFirstName} ${beneficiary.minorLastName}`;

  return (
    <div className="px-[16px] lg:px-0">
      <BeneficiaryHeader
        name={beneficiaryName}
        onManageContributions={() =>
          onManageContributions(beneficiary.accountNumber)
        }
      />
      <BeneficiaryOverview
        beneficiary={beneficiary}
        calculations={calculations}
      />
      <VestingSection beneficiary={beneficiary} calculations={calculations} />
      <ContributionsGrid
        beneficiary={beneficiary}
        calculations={calculations}
      />
    </div>
  );
};

export default BeneficiaryCard;
